import angular from 'angular';
import uiRouter from 'angular-ui-router';

import PosMovements from './movements/movements';
import PosChart from './chart/chart';

import PosComponent from './pos.component';

const dashboardPosModule = angular.module('tinaba.components.dashboard.pos', [
  uiRouter,
  PosMovements.name,
  PosChart.name
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('dashboard.pos', {
      url: '/pos',
      template: '<pos></pos>'
    });
})

.component('pos', PosComponent);

export default dashboardPosModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/dashboard/pos/pos.js
 **/